
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { ModifyTimeGridRecurrence, TimeGridRecurrence, PostTimeGridRecurrence, TimeGridRecurrenceItem } from 'interfaces/timegridRecurrence.interface';
import { API } from 'constants/api.contants';


export class TimeGridRecurrenceService {

  static getTimeGridRecurrenceById(
    timegridRecurrenceId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TimeGridRecurrence> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TIMEGRID_RECURRENCE_FULL}/${timegridRecurrenceId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TimeGridRecurrence> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getTimeGridRecurrencesBySectorIdAndDates(
    sectorId: UUID,
    dateStart: string,
    dateEnd: string,
    maxPriorityOnly: boolean,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TimeGridRecurrenceItem[]> {
    return new Promise( async resolve => {
      if ( maxPriorityOnly === undefined || maxPriorityOnly === null ) {
        maxPriorityOnly = true;
      }

      AXIOS.get( `${API.TIMEGRID_RECURRENCE_BY_SECTOR_AND_DATES}/${sectorId}/dateStart/${dateStart}/dateEnd/${dateEnd}/maxPriorityOnly/${maxPriorityOnly}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TimeGridRecurrenceItem[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static putTimeGridRecurrence(
    timegridRecurrenceId: string,
    timegridRecurrence: ModifyTimeGridRecurrence,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      AXIOS.put( `${API.TIMEGRID_RECURRENCE}/${timegridRecurrenceId}`, timegridRecurrence, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static postTimeGridRecurrence(
    timegridRecurrence: PostTimeGridRecurrence,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ id: string }> {
    return new Promise( async resolve => {
      AXIOS.post( API.TIMEGRID_RECURRENCE, timegridRecurrence, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ id: string }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static deleteTimeGridRecurrence(
    timegridRecurrenceId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.TIMEGRID_RECURRENCE}/${timegridRecurrenceId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};